
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		rangeStart: { type: String, required: true },
		rangeEnd: { type: String, required: true },
	},
});
